import ApiConfig from "../config/Api.config";
import Data from "../data/Api.data";
import Consulta from "../interfaces/Consulta.interface";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";
// import UsuarioModel from "../models/Usuario.model";

const urlSinergia: string = `${Data.URLS.urlApiSinergia}/consulta`

const guardar = async (consulta: Consulta) => {
    const request: Request = {
        url: `${urlSinergia}/guardar`,
        method: "POST",
        data: { consulta }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const listar = async (fechaInicial: string, fechaFinal: string) => {
    const request: Request = {
        url: `${urlSinergia}/listar`,
        method: "POST",
        data: { fechaInicial, fechaFinal }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const eliminar = async (IdConsulta: number) => {
    const request: Request = {
        url: `${urlSinergia}/eliminar/${IdConsulta}`,
        method: "POST",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const listarProductos = async () => {
    const request: Request = {
        url: `${urlSinergia}/productos/listar`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const causaListarProductos = async (IdProducto: string) => {
    const request: Request = {
        url: `${urlSinergia}/productos/causa/${IdProducto}/listar`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const ConsultaService = {
    /** ApiSinergia */
    listar,
    eliminar,
    listarProductos,
    causaListarProductos,
    guardar,

    
    /** REUNE */
    // ...
    // ...
    // ...
};

export default ConsultaService;
